import $ from "jquery";

window.$ = window.jQuery = $;

$(document).ready(function () {
    const $menuToggle = $(".menu__toggle .bg-icon__burger-bars-static");
    const $menuItemParents = $(".menu-item-has-children");
    const $header = $(".site-header");
    let throttleScroll;

    function toggleBurgerMenu() {
        $("body").toggleClass("menu-open").removeClass("footer-open");
    }

    function closeBurgerMenu() {
        $("body").removeClass("menu-open");
    }

    function hasScrolled() {
        let distance = $(window).scrollTop();

        if (distance > 80) {
            $header.addClass("scrolled");
        } else {
            $header.removeClass("scrolled");
        }
    }

    // Toggle all sub menus.
    $menuItemParents.on("click touch", function (e) {
        let $this = $(e.target);

        if (!$this.is("a")) {
            e.preventDefault();
            let $menuOpen = $this.hasClass("open");

            $menuItemParents.removeClass("open");
            if (true === $menuOpen) {
                $this.removeClass("open");
            } else {
                $this.addClass("open");
            }
        }
    });

    // Toggle mobile menu.
    $menuToggle.on("click touch", function (e) {
        toggleBurgerMenu();
    });

    $(document).on("scroll", function () {
        clearTimeout(throttleScroll);
        throttleScroll = setTimeout(function () {
            hasScrolled();
        }, 20);
    });
});
